// testimonial slider
const swiperTestimonial = new Swiper(".testimonial__slider", {
  loop: true,
  spaceBetween: 1,
  slidesPerView: "auto",
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".testimonial__slider-next",
    prevEl: ".testimonial__slider-prev",
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
      slidesPerView: "auto",
    },
    992: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
});

const swiperTestimonialCategories = new Swiper(".testimonial__slider__categories", {
  loop: false,
  spaceBetween: 1,
  slidesPerView: "auto",
  speed: 800,
  watchSlidesProgress: true,
  navigation: {
    nextEl: ".testimonial__slider-next",
    prevEl: ".testimonial__slider-prev",
  },
  breakpoints: {
    768: {
      spaceBetween: 32,
      slidesPerView: "auto",
    },
    992: {
      spaceBetween: 40,
      slidesPerView: 3,
    },
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
});

const testimonialButton = document.querySelector('.testimonial__tag__button');

if (testimonialButton) {
    testimonialButton.addEventListener('click', () => {
        document.querySelector('.testimonial__tag').classList.toggle('active');
    });
}

const tagBlock = document.querySelector('.testimonial__tag');
  if (tagBlock) {

    const buttons = tagBlock.querySelectorAll('[data-button]');
    const slides = document.querySelectorAll('.testimonial__slider__categories .swiper-slide');

    buttons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();

      buttons.forEach(btn => btn.classList.remove('active'));

      button.classList.add('active');

      const filterValue = button.getAttribute('data-button');
      const swiperEl = document.querySelector('.testimonial__slider__categories.swiper');
      const swiper = swiperEl?.swiper;

      slides.forEach(slide => {
          const slideValue = slide.getAttribute('data-slide');
          if (filterValue === 'all' || slideValue === filterValue) {
              slide.style.display = '';
          } else {
              slide.style.display = 'none';
          }
      });

      if (swiper && typeof swiper.update === 'function') {
        swiper.update();

        if (filterValue === 'all') {
          swiper.slideTo(0);
        } else {
          swiper.slideTo(0);
        }
      }
    });
  });
}